import { Field } from 'react-final-form';
import { Button, TextInput } from '@tokens-studio/ui';
import { Box, Flex, Label } from '../../shared/components';

interface PasswordRecoveryFormProps {
  onSubmit: () => void;
  loading: boolean;
}

export default function PasswordRecoveryForm({ onSubmit, loading }: PasswordRecoveryFormProps): JSX.Element {
  return (
    <form
      onSubmit={onSubmit}
      style={{
        width: '100%',
      }}
    >
      <Flex
        css={{
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Box
          css={{
            marginBottom: '$5',
            width: '100%',
          }}
        >
          <Field name="email">
            {(inputProps) => (
              <>
                <Box
                  css={{
                    marginBottom: '$3',
                  }}
                >
                  <Label htmlFor="email-input">E-mail</Label>
                </Box>
                <TextInput
                  placeholder="Your email address"
                  type="email"
                  {...inputProps.input}
                  id="email-input"
                  required
                />
              </>
            )}
          </Field>
        </Box>
        <Box css={{ width: '100%' }}>
          <Button variant="primary" type="submit" loading={loading}>
            Send password recovery email
          </Button>
        </Box>
      </Flex>
    </form>
  );
}
